// German for the shared flap-out shell.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Fold the chat out': 'Chat ausklappen',
  'Fold the chat in': 'Chat einklappen',
  'Jump to the latest': 'Zum Neuesten springen',
  'Enter sends · Shift+Enter starts a new line': 'Enter sendet · Shift+Enter neue Zeile',
  'Ask →': 'Fragen →',
}, 'AgentFlyout');
